/*---------------------------------------------------------------------*/
;(function($){

	/*================= Global Variable Start =================*/		   
	var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	var IEbellow9 = !$.support.leadingWhitespace;
	var iPhoneAndiPad = /iPhone|iPod/i.test(navigator.userAgent);
	var isIE = navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0;
	function isIEver () {
	  var myNav = navigator.userAgent.toLowerCase();
	  return (myNav.indexOf('msie') != -1) ? parseInt(myNav.split('msie')[1]) : false;
	}
	//if (isIEver () == 8) {}
			   
	var jsFolder = "js/";
	var cssFolder = "css/";	
	var ww = document.body.clientWidth, wh = document.body.clientHeight;
	var mobilePort = 1024, ipadView = 1024, wideScreen = 1600;
	
	/*================= Global Variable End =================*/	
	
	//css3 style calling 
	//document.write('<link rel="stylesheet" type="text/css" href="' + cssFolder +'animate.css">');	
	/*================= On Document Load Start =================*/	

	$(document).ready( function(){
		$('.skipContent').on('click',function (e) {
				e.preventDefault();			
				var target = this.hash;
				var $target = $(target);
				$('html, body').stop().animate({
					'scrollTop': $target.offset().top
				}, 1000, 'swing', function () {
					window.location.hash = target;
				});
			});
		// setTimeout(function(){
		// 		$('#loading').fadeOut();
		// 		$('.vCenter').each(function () {$(this).verticalAlign();});
		// 	}, 800);
	
		$('body').removeClass('noJS').addClass("hasJS");
		$(this).scrollTop(0);
			getWidth();	
		if( $(".searchBtn").length ){				
				$(".searchBtn").click( function(){
				event.stopPropagation();
				$(".searchBox").slideToggle();
				$(".searchBtn").toggleClass('active');
				});
			}
		$(document).mouseup(function(e){
		    var container = $(" .searchContainer");		    
		    if (!container.is(e.target) && container.has(e.target).length === 0){
		    	$(".searchBox").hide();
		    	}
			});
		// Back to Top function
		if( $("#backtotop").length){
				$(window).scroll(function(){
					if ($(window).scrollTop()>120){
					$('#backtotop').fadeIn('250').css('display','block');}
					else {
					$('#backtotop').fadeOut('250');}
				});
				$('#backtotop').click(function(){
					$('html, body').animate({scrollTop:0}, '200');
					return false;
				});
			};
	
		// Get Focus Inputbox
		if( $(".getFocus").length){
				$(".getFocus").each(function(){
				$(this).on("focus", function(){
				if ($(this).val() == $(this)[0].defaultValue) { $(this).val("");};
			  }).on("blur", function(){
				  if ($(this).val() == "") {$(this).val($(this)[0].defaultValue);};
			  });								  
			});
		};
		/*================= On Document Load and Resize Start =================*/
		$(window).on('resize', function () {
										 
			ww = document.body.clientWidth; 
			wh = document.body.clientHeight;		
			
			$('.vCenter').each(function () {$(this).verticalAlign();});	
			
			if($("body").hasClass("mobilePort")){
				$("body").removeClass("wob");
			}
			
			//$('.container').resize(function(){});
			
		}).trigger('resize');
		/*================= On Document Load and Resize End =================*/
		/*Navigation */
		if( $("#nav").length) {

			if ($(".menuPart .menu li").hasClass("ul")) {

			}
			if ($(window).width() <= 1199) {
				var navigation = $('#block-avnl-main-menu').clone();
				$(navigation).appendTo("#block-popup");

			}
			if($(".toggleMenu").length == 0){
				$("#mainNav").prepend('<a href="#" class="toggleMenu"><span class="mobileMenu">Menu</span><span class="iconBar"></span></a>');	
			}
			$(".toggleMenu").click(function() {
				$(this).toggleClass("active");
				$("#nav").slideToggle();
				return false;
			});
			$("#nav li a").each(function() {
				if ($(this).next().length) {
					$(this).parent().addClass("parent");
				};
			})
			$("#nav li.parent").each(function () {
				if ($(this).has(".menuIcon").length <= 0) $(this).append('<i class="menuIcon">&nbsp;</i>')
			});
			dropdown('nav', 'hover', 1);
			adjustMenu();	
		}
		$(document).keyup(function (e) {
			if ($('#nav li').hasClass('hover') && e.keyCode === 27) { // ESC
				$('#nav li').removeClass('hover')
			}
		});
		
		//Home Slider
		if($(".homeBanner").length){
			var homeSlider = new Swiper('.homeBanner .swiper-container', {
				spaceBetween: 0,
					speed: 2000,
					loop: true,
					keyboard: true,
					
					autoplay: {
						delay: 5000,
						disableOnInteraction: false,
					},
					pagination: false,
					navigation: {
						nextEl: '.homeBanner .slider__button-next',
						prevEl: '.homeBanner .slider__button-prev',
					},
				});
			$(".swiper-button-pause").toggle(function() {
				$(this).addClass('play');
				homeSlider.autoplay.stop();
			}, function() {
				$(this).removeClass('play');
				homeSlider.autoplay.start();
				return false;
			});
		}
		if($(".bannerImg").length){
			$(".bannerImg").each(function(){
				var imagePath = $(this).find("img").attr("src");
				$(this).css("background-image","url( "+ imagePath +" )");
			});
		}

		// note section	
		// if( $(".marqueeScrolling li").length > 1){
		// 	var $mq = $('.marquee').marquee({
		// 		 speed: 25000
		// 		,gap: 0
		// 		,duplicated: true
		// 		,pauseOnHover: true
		// 		});
		// 	$(".btnMPause").toggle(function(){
		// 		$(this).addClass('play');				
		// 		$mq.marquee('pause');
		// 	},function(){
		// 		$(this).removeClass('play');
		// 		$mq.marquee('resume');
		// 		return false;
		// 	});
		// };	

		// slider-Logo Slider
		// if ($(".slider-Logo").length) {
		// 	var avnLogo = new Swiper('.slider-Logo .swiper-container', {
		// 		loop: false,
		// 		speed:800,
		// 		slidesPerView:1,
		// 		spaceBetween:30,
		// 		autoplay: {
		// 			delay: 5000,
		// 			disableOnInteraction: false,
		// 		},
		// 		pagination: {
		// 			el: '.swiper-pagination',
		// 			clickable: true,
		// 		},
		// 		navigation: {
		// 			nextEl: '.logo-next',
		// 			prevEl: '.logo-prev',
		// 		},
		// 		breakpoints: {
		// 			1024: {
		// 				slidesPerView: 4,
		// 				spaceBetween: 30
		// 			},
		// 			767: {
		// 				slidesPerView: 3,
		// 				spaceBetween: 0
		// 			},
		// 			480: {
		// 				slidesPerView: 2,
		// 				spaceBetween: 0
		// 			}
		// 		},
		// 	});

		// 	$(".swiper-button-pause").toggle(function() {
		// 		$(this).addClass('play');
		// 		avnLogo.autoplay.stop();
		// 	}, function() {
		// 		$(this).removeClass('play');
		// 		avnLogo.autoplay.start();
		// 		return false;
		// 	});
		// }

		// Responsive Tabing Script
		if( $(".resTab").length) {
			$('.resTab').responsiveTabs({
				 rotate: false
				,startCollapsed: 'tab' //accordion
				,collapsible: 'accordion' //accordion
				,scrollToAccordion: true
				,scrollToAccordionOnLoad:false
			});
		};
		// media Slider
		// if ($(".mediaGallery").length) {
		// 	var mediaGallery = new Swiper('.mediaGallery .swiper-container', {
		// 		loop: false,
		// 		speed:800,
		// 		slidesPerView:1,
		// 		slidesPerView: "auto",
		// 		autoplay: {
		// 			delay: 5000,
		// 			disableOnInteraction: false,
		// 		},
		// 		pagination: {
		// 			el: '.swiper-pagination',
		// 			clickable: true,
		// 		},
		// 		navigation: {
		// 			nextEl: '.mediaNext',
		// 			prevEl: '.mediaPrev',
		// 		},
		// 		breakpoints: {
		// 			767: {
		// 				slidesPerView: 1,
		// 				spaceBetween: 0
		// 			}
		// 		},
		// 	});

		// 	$(".mediaarrow .swiper-button-pause").toggle(function() {
		// 		$(this).addClass('play');
		// 		mediaGallery.autoplay.stop();
		// 	}, function() {
		// 		$(this).removeClass('play');
		// 		mediaGallery.autoplay.start();
		// 		return false;
		// 	});
		// }
		// photoGallery Slider
	// 	if ($(".photoGallery").length) {
	// 	var photoGallery = new Swiper('.photoGallery .swiper-container', {
	// 		loop: false,
	// 		speed:200,
	// 		slidesPerView:1,
	// 		slidesPerView: "auto",
	// 		autoplay: {
	// 			delay: 5000,
	// 			disableOnInteraction: false,
	// 		},
	// 		pagination: {
	// 			el: '.swiper-pagination',
	// 			clickable: true,
	// 		},
	// 		navigation: {
	// 			nextEl: '.mediaNext',
	// 			prevEl: '.mediaPrev',
	// 		},
	// 		breakpoints: {
	// 			767: {
	// 				slidesPerView: 1,
	// 				spaceBetween: 0
	// 			}
	// 		},
	// 	});
	// 	$(".photoGallery .swiper-button-pause").toggle(function() {
	// 		$(this).addClass('play');
	// 		photoGallery.autoplay.stop();
	// 	}, function() {
	// 		$(this).removeClass('play');
	// 		photoGallery.autoplay.start();
	// 		return false;
	// 	});
	// }

		// magnificPopup js
		$(document).ready(function(){
		    // setTimeout(function() {
		    //     $('.galleryItem').magnificPopup({
		    //         delegate: 'a',
		    //         type: 'image',
		    //         tLoading: 'Loading image #%curr%...',
		    //         mainClass: 'mfp-img-mobile',
		    //         gallery: {
		    //             enabled: true,
		    //             navigateByImgClick: true,
		    //             preload: [0, 1]
		    //         },
		    //         image: {
		    //             tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
		    //             titleSrc: function (item) {
		    //                 return item.el.attr('title') + '<small>by Marsel Van Oosten</small>';
		    //             }
		    //         }
		    //     });
		    // }, 100); // Change 2000 to the delay time you want in milliseconds
			Fancybox.bind('[data-fancybox="gallery"]', {
				//
			  });    
		});
		
		// Multiple Ticker 1	
		// if( $(".ticker").length){
		// 	$('.ticker').each(function(i){
		// 		$(this).addClass('tickerDiv'+i).attr('id', 'ticker'+i);
		// 		$('#ticker'+i).find('.tickerDivBlock').first().addClass('newsTikker'+i).attr('id', 'newsTikker'+i);
		// 		$('#ticker'+i).find('a.playPause').attr('id', 'stopNews'+i)
		// 		$('#newsTikker'+i).vTicker({ speed: 1E3, pause: 4E3, mousePause: false, showItems: 4, height: 230, direction: 'up' })
		// 		$("#stopNews"+i).click(function () {
		// 			if($(this).hasClass('stop')){
		// 				$(this).removeClass("stop").addClass("play").text("Play").attr('title', 'Play');
		// 			}else{
		// 				$(this).removeClass("play").addClass("stop").text("Pause").attr('title', 'pause');
		// 			}
		// 			return false;
		// 		});
		// 	});
		// };
		if($('.headerRowRight').length){
			$('#slide').click(function () {
				var hidden = $('.menuMobileRight');
				if (hidden.hasClass('visible')) {
					hidden.animate({ "right": "-1000px" }, "slow").removeClass('visible');
				} else {
					hidden.css("right", "-1000px"); // Ensure it's initially off-screen
					hidden.animate({ "right": "0px" }, "slow").addClass('visible');
				}
			});
			
			$(".btn-close").click(function () {
				$('.menuMobileRight').animate({ "right": "-1000px" }, "slow").removeClass('visible');
			});
			
			// Hide menuMobileRight when the Esc key is pressed
			$(document).on('keydown', function (event) {
				if (event.key === 'Escape') {
					var hidden = $('.menuMobileRight');
					if (hidden.hasClass('visible')) {
						hidden.animate({ "right": "-1000px" }, "slow").removeClass('visible');
					}
				}
			});			
		}


		// To open External link Dialogbox for External links
		$('a').not(".litebox, .colorbox-load, .w3cLogos a, .videoPopupLink").filter(function() {
			return this.hostname && this.hostname !== location.hostname;
			}).click(function(e) {  
				e.preventDefault();
				var url = $(this).attr("href");		 
				smoke.confirm("This is external link. Please note that Swavlambancard website cannot be held responsible for external websites content & privacy policies. Are you sure you want to continue?", function(e){
				if (e){ 
					window.open(url, "_blank");		
				}else{ 
					return false; 
				}
			}, {
				ok: "Yes",
				cancel: "No",
				classname: "custom-class",
				reverseButtons: true
			}); 
		});	


		/*if ($(window).width() <= 1024) {
			$("#nav").clone().appendTo("#navMob");
			$("#navMob").find("#nav").show();
			$(".menuIcon").click(function(){
				$(this).prev().slideToggle();
			});
		}else{

		}*/

		//if ($(".mobileNav").length) {
	        var navigation = $('#nav').clone();
	        $(navigation).prependTo(".offcanvas-body").wrap("<div class='mobileNav'></div>");
	        //if ($(".mobileNav #navMob").length) {
	            $(".mobileNav #nav").attr("id", "navMob");
	       // }
	        $("#navMob").show();
			$(".menuIcon").click(function(){
				$(this).prev().slideToggle();
			});
	   // }

	   //register 
	   $('.register ul.bulletText li').on('click', function(){
		$('.register ul.bulletText li.active').removeClass('active');
		$(this).addClass('active');
		});
		
		
});
	

	/*================= On Window Resize Start =================*/	
	$(window).bind('resize orientationchange', function() {
		getWidth();												
		adjustMenu();
		$('.vCenter').each(function () {$(this).verticalAlign();});
	});
		
	function getWidth(){
		ww = document.body.clientWidth;
		if(ww>wideScreen){$('body').removeClass('device').addClass('desktop widerDesktop');}
		if(ww>mobilePort && ww<=wideScreen){	$('body').removeClass('device widerDesktop').addClass('desktop');}
		if(ww<=mobilePort) {$('body').removeClass('desktop widerDesktop').addClass('device');}
		if(ww > 767 && ww < 1025){$('body').addClass('ipad');}
		else {$('body').removeClass('ipad');}	
	}
	})(jQuery);
	